module.exports = __webpack_public_path__ + "static/FuturaPT-BoldObl-bbc1236f665b9b43b0eb3095277fb298.woff2";